export const parties = {
  parties: [],
  loading: {
    isLoadingParties: false,
    isLoadingParty: false,
  },
  strings: {
    title: 'Parties',
    subtitle: undefined,
    'title.party.list': 'Party',
    'title.parties.list': 'Parties',
    // <PARTIES>
    'parties.controls.info.label': 'party(s) found',
    'parties.grid.cell.actions.btn.view.label': 'View',
    'parties.grid.cell.actions.btn.edit.label': 'Edit',
    'parties.grid.cell.actions.btn.cancel.label': 'Cancel',
    'parties.grid.cell.actions.btn.modify.label': 'Modify',

    'parties.grid.column.id.label': 'Id',
    'parties.grid.column.partyName.label': 'Subscriber',
    'parties.grid.column.status.label': 'Status',
    'parties.grid.column.partyId.label': 'Party',
    'parties.grid.column.createdOn.label': 'Creation Date',
    'parties.grid.column.date.label': 'Effective Date',
    'parties.grid.column.commercialProductName.label': 'Product',

    'parties.grid.column.actions.label': 'Actions',

    'parties.filter.label': 'Filtres',
    // </PARTIES>
  },
};
